import { useEffect, useState } from "react";
import axios from "axios";
import { API, IMAGES } from "@/data/site";
import { PackageCard } from "@/components/home/Destinations";
import PageHero from "@/components/PageHero";
import { Accent, Reveal, SectionHead } from "@/components/Reveal";
import { Globe2, Luggage, Plane } from "lucide-react";

const PERKS = [
  { icon: Plane, title: "Flights & visas handled", text: "End-to-end ticketing, visa guidance and travel insurance." },
  { icon: Globe2, title: "On-ground partners", text: "Trusted local teams in 20+ countries, reachable through us 24×7." },
  { icon: Luggage, title: "Zero-stress logistics", text: "Transfers, stays and experiences confirmed before you pack." },
];

const International = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/packages`, { params: { type: "international" } })
      .then((r) => setPackages(r.data))
      .catch(() => setPackages([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="international-page">
      <PageHero
        image={IMAGES.intlService}
        eyebrow="International Tours"
        title={<>The world, <Accent>first-class</Accent> planned</>}
        text="Islands, Alps and skylines — with visas, flights and every transfer sorted before you leave home."
      />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        {loading ? (
          <p className="text-[#F5F5F0]/50 text-sm">Loading destinations…</p>
        ) : (
          <div className="flex flex-wrap gap-6">
            {packages.map((p) => (
              <PackageCard key={p.id} pkg={p} />
            ))}
          </div>
        )}
        <div className="grid sm:grid-cols-3 gap-6 mt-20">
          {PERKS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <div className="glass rounded-3xl p-7">
                <span className="w-11 h-11 rounded-2xl bg-[#F2C230]/15 flex items-center justify-center text-[#F2C230]">
                  <p.icon size={19} />
                </span>
                <h3 className="font-sora text-base font-semibold mt-4">{p.title}</h3>
                <p className="text-sm text-[#F5F5F0]/60 mt-2 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24">
        <Reveal>
          <div className="glass rounded-3xl p-10 sm:p-14 text-center">
            <SectionHead
              align="center"
              eyebrow="Honeymoons & Groups"
              title={<>Somewhere else in <Accent>mind?</Accent></>}
              text="Europe rail loops, Japan in blossom season, an African safari — if there's a runway, we'll get you there."
            />
            <a href="/contact" data-testid="intl-custom-cta" className="btn-gold mt-8 inline-flex">
              Plan an International Trip
            </a>
          </div>
        </Reveal>
      </section>
    </main>
  );
};

export default International;
